<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-spacer></v-spacer>
      <v-btn color="primary" dark v-if="showCoinsSvcFeeBtn" @click.prevent="coinsSvcFeeDialog = true">
        Coinsurance Service Fee
        <v-icon dark right>mdi-cash-usd</v-icon>
      </v-btn>
      <v-flex xs12>
        <v-card>
          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-card>
                    <v-toolbar dense color="grey lighten-5" flat>
                      <v-icon>mdi-format-align-justify</v-icon>
                      <v-toolbar-title class="toolbar-title-2">RI Headers</v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-btn class="mx-2" fab dark small color="primary" v-if="!showRiForm" @click.prevent="doAdd" :loading="loading">
                        <v-icon dark>mdi-plus</v-icon>
                      </v-btn>
                    </v-toolbar>
                    <v-card-text>
                      <v-container fluid grid-list-lg>
                        <v-flex xs12 class="mt-3" v-if="messages.length > 0">
                          <message :messages="messages"></message>
                        </v-flex>
                        <v-layout row wrap>
                          <v-flex xs12>
                            <v-data-table
                              v-bind:headers="listRIHeaders"
                              v-bind:items="riHeaderItems"
                              :server-items-length="totalItemsRI"
                              :footer-props="{'items-per-page-options': itemsPerPage }"
                              v-bind:options.sync="paginationRI"
                              item-key="key"
                              :loading="loading"
                              :no-data-text="noDataText"
                            >
                              <template v-slot:item="row">
                                <tr :class="{ activeRow: selectedRecord == row.item.riType + '-' + row.item.riCoDesc + '-' + row.item.acctNoSfx }" @dblclick="doEdit(row.item)">
                                  <td v-for="column in selectedRIColumns" :key="column">
                                    {{ column === 'riType' ? getRIType(row.item[column]).label : row.item[column] }}
                                  </td>
                                  <td class="table-action-header">
                                    <table-action
                                      :rowData="row"
                                      review
                                      @review="doEdit(row.item)"
                                      remove
                                      @remove="doPromptRemove(row.item)"
                                    ></table-action>
                                  </td>
                                </tr>
                              </template>
                            </v-data-table>
                          </v-flex>
                        </v-layout>
                        <!--Start Delete Prompt -->
                        <confirm v-model="promptRemove" @ok="doDelete">
                          <p>{{ labels.promptRemove }}</p>
                          <div class="queryValue">{{ deleteRIHeader }}</div>
                        </confirm>
                        <!-- End Delete Prompt-->
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12>
                  <v-card id="riFormCard">
                    <v-toolbar dense color="grey lighten-5" flat>
                      <div class="v-icon mdi mdi-leaf theme--light d-flex">
                        <span class="headerTitle-b" v-if="newRiHeader"
                          >{{riHeaderDisplay}} RI Header
                          <span class="caption grey--text font-weight-light">(New)</span>
                        </span>
                        <span class="headerTitle-b" v-else-if="queryMode"
                          >{{riHeaderDisplay}} RI Header
                          <span class="caption grey--text font-weight-light">(Query)</span>
                        </span>
                        <span class="headerTitle-b" v-else
                          >{{riHeaderDisplay}} RI Header
                          <span class="caption grey--text font-weight-light">(Review)</span>
                        </span>
                      </div>
                      <v-spacer></v-spacer>
                      <v-btn icon @click.native="showRiForm = !showRiForm">
                        <v-icon primary v-if="showRiForm">mdi-chevron-down</v-icon>
                        <v-icon primary v-else>mdi-chevron-up</v-icon>
                      </v-btn>
                    </v-toolbar>
                    <v-card-text v-if="showRiForm">
                      <v-layout row wrap>
                        <v-flex xs6 md6 lg4>
                          <v-autocomplete
                            @input="checkRiType"
                            v-model="riForm.riType"
                            v-validate="riTypeValidation"
                            :items="riTypeList"
                            :label="labels.riType"
                            item-text="label"
                            item-value="value"
                            data-vv-name="riType"
                            :error-messages="errors.collect('riType')"
                            :data-vv-as="labels.riType"
                            :disabled="!newRiHeader"
                            @change="contractCertaintyDisplayChanged"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs6 md6 lg8>
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn class="mx-2" fab dark small color="purple" v-on="on" @click.prevent="openRiAppTxt">
                                <v-icon dark>mdi-note-text</v-icon>
                              </v-btn>
                            </template>
                            <span>RI Application Text</span>
                          </v-tooltip>
                        </v-flex>
                        <v-flex xs6 md6 lg4>
                          <v-text-field
                            :disabled="riForm.riType === undefined || !newRiHeader"
                            v-model="riForm.riCoWithDesc"
                            v-validate="treatyRiCoValidation"
                            :label="labels.riCo"
                            data-vv-name="riCo"
                            :data-vv-as="labels.riCo"
                            :error-messages="errors.collect('riCo')"
                            @change="changeRiCo"
                          >
                            <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                              <v-icon v-if="riForm.riType !== undefined" color="info" @click="doShowRiCo" v-text="'mdi-magnify'"></v-icon>
                            </v-slide-x-reverse-transition>
                          </v-text-field>
                        </v-flex>
                        <v-flex xs6 md6 lg4>
                          <v-autocomplete
                            :disabled="riForm.riType !== 'F'"
                            v-model="riForm.propXl"
                            v-validate="riTypeFaculativeValidate"
                            :items="proplXolList"
                            :label="labels.propXl"
                            item-text="label"
                            item-value="value"
                            data-vv-name="propXl"
                            :error-messages="errors.collect('propXl')"
                            :data-vv-as="labels.propXl"
                            clearable
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs6 md6 lg4>
                          <v-autocomplete
                            :disabled="
                              riForm.riType === 'D' || riForm.riType === 'T' || riForm.riType === 'W' || riForm.riType === undefined || !newRiHeader
                            "
                            v-model="riForm.acctNoSfx"
                            v-validate="'required'"
                            :items="riAcctNoSfxListItems"
                            item-text="acctNoSfxWithDesc"
                            item-value="acctNoSfx"
                            :label="labels.acctNoSfx"
                            data-vv-name="acctNoSfx"
                            :data-vv-as="labels.acctNoSfx"
                            :error-messages="errors.collect('acctNoSfx')"
                          >
                            <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                              <v-icon
                                v-if="riForm.riType === 'F' || riForm.riType === 'C'"
                                @click="doShowAcctNoSfx"
                                color="info"
                                v-text="'mdi-magnify'"
                              ></v-icon>
                            </v-slide-x-reverse-transition>
                          </v-autocomplete>
                        </v-flex>
                        <v-flex xs6 md6 lg4>
                          <v-text-field
                            :disabled="riForm.riType !== 'F'"
                            v-model="riForm.theirPolNo"
                            :label="labels.theirPolNo"
                            :data-vv-as="labels.theirPolNo"
                            v-validate="'entry'"
                            data-vv-name="theirPolNo"
                            :error-messages="errors.collect('theirPolNo')"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6 md6 lg4>
                          <v-text-field
                            v-model="riForm.cesNo"
                            :label="labels.cesNo"
                            :data-vv-as="labels.cesNo"
                            v-validate="'entry'"
                            data-vv-name="cesNo"
                            :error-messages="errors.collect('cesNo')"
                            :disabled="!newRiHeader"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6 md6 lg4>
                          <v-text-field
                            v-model="riForm.cesYr"
                            :label="labels.cesYr"
                            :data-vv-as="labels.cesYr"
                            v-validate="'entry'"
                            data-vv-name="cesYr"
                            :error-messages="errors.collect('cesYr')"
                            :disabled="!newRiHeader || newRiHeader"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6 md6 lg4>
                          <v-text-field
                            v-model="riForm.docNo"
                            :label="labels.docNo"
                            :data-vv-as="labels.docNoNo"
                            v-validate="'entry'"
                            data-vv-name="docNoNo"
                            :error-messages="errors.collect('docNoNo')"
                            :disabled="true"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6 md6 lg4>
                          <v-text-field
                            v-model="riForm.cesEndtNo"
                            :label="labels.cesEndtNo"
                            :data-vv-as="labels.cesEndtNo"
                            v-validate="'entry'"
                            data-vv-name="cesEndtNo"
                            :error-messages="errors.collect('cesEndtNo')"
                            :disabled="true"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6 md6 lg4>
                          <v-text-field
                            v-model="riForm.cesStamp"
                            v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                            :label="labels.cesStamp"
                            :data-vv-as="labels.cesStamp"
                            v-validate="'entry'"
                            data-vv-name="cesStamp"
                            :error-messages="errors.collect('cesStamp')"
                            :disabled="true"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6 md6 lg4>
                          <v-checkbox
                            left
                            color="primary"
                            v-model="riForm.bordEreAux"
                            :label="labels.bordEreAux"
                            @change="bordEreAuxChanged"
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs6 md6 lg4>
                          <v-checkbox left color="primary" v-model="riForm.prtRiApp" :label="labels.prtRiApp" :disabled="riForm.riType === 'W'"></v-checkbox>
                        </v-flex>
                        <v-flex xs6 md6 lg4>
                          <v-checkbox left color="primary" v-model="riForm.relRi" :label="labels.relRi"></v-checkbox>
                        </v-flex>
                        <v-flex xs6 md6 lg4>
                          <cal-picker
                            v-model="riForm.tranDate"
                            v-validate="tranDateValidation"
                            :label="labels.tranDate"
                            :data-vv-as="labels.tranDate"
                            data-vv-name="tranDate"
                            :error-messages="errors.collect('tranDate')"
                            @change="checkTranDate"
                          ></cal-picker>
                        </v-flex>
                        <v-flex xs12 md6 lg4>
                          <cal-picker
                            v-model="riForm.riComDate"
                            v-validate="comDateValidation"
                            :label="labels.riComDate"
                            :data-vv-as="labels.riComDate"
                            data-vv-name="riComDate"
                            :error-messages="errors.collect('riComDate')"
                          ></cal-picker>
                        </v-flex>
                        <v-flex xs12 md6 lg4>
                          <cal-picker
                            v-model="riForm.riExpDate"
                            v-validate="expDateValidation"
                            :label="labels.riExpDate"
                            :data-vv-as="labels.riExpDate"
                            data-vv-name="riExpDate"
                            :error-messages="errors.collect('riExpDate')"
                          ></cal-picker>
                        </v-flex>
                        <v-flex xs12 md6 lg4>
                          <cal-picker
                            v-model="riForm.riEndtDate"
                            v-validate="riForm.cesEndtCnt === 0 ? endtDateValidation : 'required'"
                            :label="labels.riEndtDate"
                            :data-vv-as="labels.riEndtDate"
                            data-vv-name="riEndtDate"
                            :error-messages="errors.collect('riEndtDate')"
                            :disabled="riForm.cesEndtCnt === 0"
                          ></cal-picker>
                        </v-flex>
                        <v-flex xs12 md6 lg4>
                          <v-text-field v-model="riForm.billCurr" :label="labels.billCurr" :disabled="true"></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6 lg4> </v-flex>
                        <v-flex xs6 md6 lg4>
                          <v-layout row wrap>
                            <v-flex lg1>
                              <v-checkbox left color="primary" v-model="riForm.comm1AE" @change="checkRIComm1AE()"></v-checkbox>
                            </v-flex>
                            <v-flex lg8>
                              <v-text-field
                                v-model="riForm.comm1Pct"
                                v-num-mask="{ negative: true, intScale: 18, decScale: 6 }"
                                :label="labels.comm1Pct"
                                :data-vv-as="labels.comm1Pct"
                                v-validate="'required'"
                                data-vv-name="comm1Pct"
                                :error-messages="errors.collect('comm1Pct')"
                                :disabled="riForm.comm1AE"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs6 md6 lg4>
                          <v-layout row wrap>
                            <v-flex xs2 md1 lg1>
                              <v-checkbox left color="primary" v-model="riForm.comm2AE" @change="checkRIComm2AE(newRiHeader)"></v-checkbox>
                            </v-flex>
                            <v-flex xs5 md6 lg6>
                              <v-text-field
                                v-model="riForm.comm2Pct"
                                v-num-mask="{ negative: true, intScale: 18, decScale: 6 }"
                                :label="labels.comm2Pct"
                                :data-vv-as="labels.comm2Pct"
                                v-validate="'required'"
                                data-vv-name="comm2Pct"
                                :error-messages="errors.collect('comm2Pct')"
                                :disabled="riForm.comm2AE"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs5 md5 lg5>
                              <v-autocomplete
                                v-model="riForm.comm2Gn"
                                v-validate="'required'"
                                :items="grossNetList"
                                :label="labels.comm2Gn"
                                item-text="label"
                                item-value="value"
                                data-vv-name="comm2Gn"
                                :error-messages="errors.collect('comm2Gn')"
                                :data-vv-as="labels.comm2Gn"
                              ></v-autocomplete>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs6 md6 lg4>
                          <v-layout row wrap>
                            <v-flex xs2 md1 lg1>
                              <v-checkbox left color="primary" v-model="riForm.comm3AE" @change="checkRIComm3AE(newRiHeader)"></v-checkbox>
                            </v-flex>
                            <v-flex xs5 md6 lg6>
                              <v-text-field
                                v-model="riForm.comm3Pct"
                                v-num-mask="{ negative: true, intScale: 18, decScale: 6 }"
                                :label="labels.comm3Pct"
                                :data-vv-as="labels.comm3Pct"
                                v-validate="'required'"
                                data-vv-name="comm3Pct"
                                :error-messages="errors.collect('comm3Pct')"
                                :disabled="riForm.comm3AE"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs5 md5 lg5>
                              <v-autocomplete
                                v-model="riForm.comm3Gn"
                                v-validate="'required'"
                                :items="grossNetList"
                                :label="labels.comm3Gn"
                                item-text="label"
                                item-value="value"
                                data-vv-name="comm3Gn"
                                :error-messages="errors.collect('comm3Gn')"
                                :data-vv-as="labels.comm3Gn"
                              ></v-autocomplete>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs6 md6 lg4>
                          <v-text-field
                            v-model="riForm.stampDuty"
                            v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                            :label="labels.stampDuty"
                            :data-vv-as="labels.stampDuty"
                            v-validate="'entry'"
                            data-vv-name="stampDuty"
                            :error-messages="errors.collect('stampDuty')"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6 md6 lg4>
                          <v-text-field
                            v-model="riForm.riTax"
                            v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                            :label="labels.riTax"
                            :data-vv-as="labels.riTax"
                            v-validate="'entry'"
                            data-vv-name="riTax"
                            :error-messages="errors.collect('riTax')"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6 md6 lg4>
                          <v-text-field
                            v-model="riForm.riLevy"
                            v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                            :label="labels.riLevy"
                            :data-vv-as="labels.riLevy"
                            v-validate="'entry'"
                            data-vv-name="riLevy"
                            :error-messages="errors.collect('riLevy')"
                          ></v-text-field>
                        </v-flex>
                        <transition name="slide-y-transition" mode="out-in">
                          <v-flex xs12 v-if="checkContractCertaintyDisplay">
                            <v-card>
                              <v-toolbar dense color="grey lighten-5" flat>
                                <v-icon>mdi-format-align-justify</v-icon>
                                <v-toolbar-title class="toolbar-title-3">Contract Certainty</v-toolbar-title>
                              </v-toolbar>
                              <v-card-text>
                                <v-layout row wrap>
                                  <v-flex xs6 md6 lg4>
                                    <cal-picker
                                      v-model="riForm.ccaDate"
                                      :label="labels.ccaDate"
                                      :data-vv-as="labels.ccaDate"
                                      data-vv-name="ccaDate"
                                      :error-messages="errors.collect('ccaDate')"
                                    />
                                  </v-flex>
                                  <v-flex xs6 md6 lg4>
                                    <cal-picker
                                      v-model="riForm.ccdDate"
                                      :label="labels.ccdDate"
                                      :data-vv-as="labels.ccdDate"
                                      data-vv-name="ccdDate"
                                      :error-messages="errors.collect('ccdDate')"
                                    />
                                  </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                  <v-flex xs6 md6 lg4 v-if="riForm.ccDateEntUsr">
                                    <v-subheader class="queryLabel">{{ labels.ccDateEntUsr }}</v-subheader>
                                    <div class="queryValue">{{ riForm.ccDateEntUsr }}</div>
                                  </v-flex>
                                  <v-flex xs6 md6 lg4 v-if="riForm.ccDateRevUsr">
                                    <v-subheader class="queryLabel">{{ labels.ccDateRevUsr }}</v-subheader>
                                    <div class="queryValue">{{ riForm.ccDateRevUsr }}</div>
                                  </v-flex>
                                </v-layout>
                              </v-card-text>
                            </v-card>
                          </v-flex>
                        </transition>
                      </v-layout>
                    </v-card-text>
                    <v-card-actions v-if="showRiForm">
                      <v-spacer></v-spacer>
                      <v-btn depressed text @click.native="showRiForm = false" :loading="loading">
                        <span class="btn-normal-error">Cancel</span></v-btn
                      >
                      <v-btn depressed v-show="!queryMode" text @click.native="doSaveRiHeader" :loading="loading">
                        <span class="btn-normal-primary">Save</span></v-btn
                      >
                    </v-card-actions>
                  </v-card>
                  <v-spacer class="mt-1"></v-spacer>
                  <v-card v-if="!disableRiOutRiskPrem">
                    <v-toolbar dense color="grey lighten-5" flat>
                      <div class="v-icon mdi mdi-format-list-bulleted theme--light d-flex">
                        <span class="headerTitle-b">{{riHeaderDisplay}} RI Details</span>
                      </div>
                      <v-spacer></v-spacer>
                      <v-btn icon @click.native="showRiDetails = !showRiDetails">
                        <v-icon primary v-if="showRiDetails">mdi-chevron-down</v-icon>
                        <v-icon primary v-else>mdi-chevron-up</v-icon>
                      </v-btn>
                    </v-toolbar>
                    <v-card-text v-if="showRiDetails">
                      <v-data-table
                        :headers="listRIDetails"
                        :items="riDetailItems"
                        :server-items-length="totalItemsRiDetail"
                        :footer-props="{'items-per-page-options': itemsPerPage }"
                        :options.sync="paginationRiDetail"
                        item-key="key"
                        :loading="loading"
                        :no-data-text="noDataText"
                        :calculate-widths=true
                      >
                        <template v-slot:item="row">
                          <tr>
                            <td v-for="column in selectedRIDetailColumns" :key="column">
                              {{ column === 'riSI' || column === 'riNetPremDisp' ? formatMoney(row.item[column]) : (column === 'riskNo' ? row.item['riskGrpNo'].toString().padStart(2, '0') + '/' + row.item[column].toString().padStart(3, '0') : row.item[column] )  }}
                            </td>
                            <td class="table-action-header">
                              <table-action :rowData="row" review @review="doReviewDetails(row.item)"></table-action>
                            </td>
                          </tr>
                        </template>
                        <template v-slot:footer>
                          <v-simple-table>
                            <tbody>
                              <tr>
                                <td style="width: 95px"></td>
                                <td style="width: 95px"></td>
                                <td class="text-right"  style="width: 95px">
                                  <strong>Total:</strong>
                                </td>
                                <td style="width: 95px">{{ getRIPremiumTotal }}</td>
                                <td style="width: 95px">{{ getRIComm1Total }}</td>
                                <td style="width: 95px">{{ getRIComm2Total }}</td>
                                <td style="width: 95px">{{ getRIComm3Total }}</td>
                                <td style="width: 95px">{{ getRINetPremTotal }}</td>
                                <td style="width: 95px">{{ getRILevyTotal }}</td>
                                <td style="width: 95px">{{ getRITaxTotal }}</td>
                                <td style="width: 89px"></td>
                              </tr>
                            </tbody>
                          </v-simple-table>
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                  <v-spacer class="mt-1"></v-spacer>
                  <v-card id="riDetailFormCard" v-if="!disableRiOutRiskPrem">
                    <v-toolbar dense color="grey lighten-5" flat>
                      <div class="v-icon mdi mdi-format-align-justify theme--light d-flex">
                        <span class="headerTitle-b"
                          >{{riHeaderDisplay}} RI Details for
                          <span class="caption grey--text font-weight-light">({{ riDetailLabels.riskDesc }}: {{ riDetailForm.riskDesc }})</span>
                        </span>
                      </div>
                      <v-spacer></v-spacer>
                      <v-btn icon @click.native="showRiDetailForm = !showRiDetailForm">
                        <v-icon primary v-if="showRiDetailForm">mdi-chevron-down</v-icon>
                        <v-icon primary v-else>mdi-chevron-up</v-icon>
                      </v-btn>
                    </v-toolbar>
                    <v-card-text v-if="showRiDetailForm">
                      <v-layout row wrap>
                        <v-flex xs6 md6 lg6>
                          <v-layout>
                            <v-flex xs1 md1 lg1>
                              <v-checkbox left color="primary" v-model="riDetailForm.riSIPctAE" @change="recalculate"></v-checkbox>
                            </v-flex>
                            <v-flex xs10 md10 lg10>
                              <v-text-field
                                v-model="riDetailForm.riSIPct"
                                :label="riDetailLabels.riSIPct"
                                :data-vv-as="riDetailLabels.riSIPct"
                                v-if="riForm.riType == 'W'"
                                data-vv-name="riSIPct"
                                :error-messages="errors.collect('riSIPct')"
                                :disabled="riDetailForm.riSIPctAE"
                                v-validate="'max_value:100'"
                                @blur="recalculate"
                              />
                              <v-text-field
                                v-model="riDetailForm.riSIPct"
                                :label="riDetailLabels.riSIPct"
                                :data-vv-as="riDetailLabels.riSIPct"
                                v-validate="riSIPctValidation"
                                data-vv-name="riSIPct"
                                v-else
                                :error-messages="errors.collect('riSIPct')"
                                :disabled="riDetailForm.riSIPctAE"
                                @blur="recalculate"
                              />
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs6 md6 lg6>
                          <v-layout>
                            <v-flex xs1 md1 lg1>
                              <v-checkbox left color="primary" v-model="riDetailForm.riSIAE" @change="recalculate" />
                            </v-flex>
                            <v-flex xs10 md10 lg10>
                              <v-text-field
                                v-model="riDetailForm.riSI"
                                :label="riDetailLabels.riSI"
                                v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                                :data-vv-as="riDetailLabels.riSI"
                                v-validate="'entry'"
                                data-vv-name="riSI"
                                :error-messages="errors.collect('riSI')"
                                :disabled="riDetailForm.riSIAE"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs6 md6 lg6>
                          <v-layout>
                            <v-flex xs1 md1 lg1>
                              <v-checkbox left color="primary" v-model="riDetailForm.riPremAE" @change="recalculate" />
                            </v-flex>
                            <v-flex xs10 md10 lg10>
                              <v-text-field
                                v-model="riDetailForm.riPrem"
                                :label="riDetailLabels.riPrem"
                                :data-vv-as="riDetailLabels.riPrem"
                                v-validate="'entry'"
                                data-vv-name="riPrem"
                                :error-messages="errors.collect('riPrem')"
                                :disabled="riDetailForm.riPremAE"
                                @blur="recalculate"
                              />
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs6 md6 lg6>
                          <v-layout>
                            <v-flex xs1 md1 lg1></v-flex>
                            <v-flex xs10 md10 lg10>
                              <v-text-field
                                v-model="riDetailForm.prtyLim"
                                :label="riDetailLabels.prtyLim"
                                v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                                :data-vv-as="riDetailLabels.prtyLim"
                                v-validate="'entry'"
                                data-vv-name="prtyLim"
                                :error-messages="errors.collect('prtyLim')"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs6 md6 lg6 order-lg1 order-md1>
                          <v-layout>
                            <v-flex xs1 md1 lg1>
                              <v-checkbox left color="primary" v-model="riDetailForm.riComm1AE" @change="recalculate" />
                            </v-flex>
                            <v-flex xs10 md10 lg10>
                              <v-text-field
                                v-model="riDetailForm.riComm1"
                                :label="riDetailLabels.riComm1"
                                v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                                :data-vv-as="riDetailLabels.riComm1"
                                v-validate="'entry'"
                                data-vv-name="riComm1"
                                :error-messages="errors.collect('riComm1')"
                                :disabled="riDetailForm.riComm1AE"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs6 md6 lg6 order-lg3 order-md3>
                          <v-layout>
                            <v-flex xs1 md1 lg1>
                              <v-checkbox left color="primary" v-model="riDetailForm.riComm2AE" @change="recalculate" />
                            </v-flex>
                            <v-flex xs10 md10 lg10>
                              <v-text-field
                                v-model="riDetailForm.riComm2"
                                :label="riDetailLabels.riComm2"
                                v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                                :data-vv-as="riDetailLabels.riComm2"
                                v-validate="'entry'"
                                data-vv-name="riComm2"
                                :error-messages="errors.collect('riComm2')"
                                :disabled="riDetailForm.riComm2AE"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs6 md6 lg6 order-lg5 order-md5>
                          <v-layout>
                            <v-flex xs1 md1 lg1>
                              <v-checkbox left color="primary" v-model="riDetailForm.riComm3AE" @change="recalculate" />
                            </v-flex>
                            <v-flex xs10 md10 lg10>
                              <v-text-field
                                v-model="riDetailForm.riComm3"
                                :label="riDetailLabels.riComm3"
                                v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                                :data-vv-as="riDetailLabels.riComm3"
                                v-validate="'entry'"
                                data-vv-name="riComm3"
                                :error-messages="errors.collect('riComm3')"
                                :disabled="riDetailForm.riComm3AE"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs6 md6 lg6 order-lg2 order-md2>
                          <v-layout>
                            <v-flex xs1 md1 lg1>
                              <v-checkbox left color="primary" v-model="riDetailForm.riLevyAE"></v-checkbox>
                            </v-flex>
                            <v-flex xs10 md10 lg10>
                              <v-text-field
                                v-model="riDetailForm.riLevy"
                                :label="riDetailLabels.riLevy"
                                v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                                :data-vv-as="riDetailLabels.riLevy"
                                v-validate="'entry'"
                                data-vv-name="riLevy"
                                :error-messages="errors.collect('riLevy')"
                                :disabled="riDetailForm.riLevyAE"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs6 md6 lg6 order-lg4 order-md4>
                          <v-layout>
                            <v-flex xs1 md1 lg1>
                              <v-checkbox left color="primary" v-model="riDetailForm.riTaxAE"></v-checkbox>
                            </v-flex>
                            <v-flex xs10 md10 lg10>
                              <v-text-field
                                v-model="riDetailForm.riTax"
                                :label="riDetailLabels.riTax"
                                v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                                :data-vv-as="riDetailLabels.riTax"
                                v-validate="'entry'"
                                data-vv-name="riTax"
                                :error-messages="errors.collect('riTax')"
                                :disabled="riDetailForm.riTaxAE"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                    <v-card-actions v-if="showRiDetailForm">
                      <v-spacer></v-spacer>
                      <v-btn depressed text @click.native="showRiDetailForm = false" :loading="loading">
                        <span class="btn-normal-error">Cancel</span></v-btn
                      >
                      <v-btn depressed v-show="!queryMode" text @click.native="doSaveRiDetail" :loading="loading">
                        <span class="btn-normal-primary">Save</span></v-btn
                      >
                    </v-card-actions>
                  </v-card>
                  <v-spacer class="mt-1"></v-spacer>
                  <v-card v-if="showRiOutBord">
                    <v-toolbar dense color="grey lighten-5" text>
                      <v-icon>mdi-format-align-justify</v-icon>
                      <v-toolbar-title class="toolbar-title-2">Bordereaux Item Details</v-toolbar-title>
                      <v-spacer></v-spacer>
                      <!-- <v-btn class="mx-2" fab dark small color="primary"
                        @click.prevent="doAddRiOutBord" :loading="loading">
                        <v-icon dark>mdi-plus</v-icon>
                      </v-btn> -->
                    </v-toolbar>
                    <v-card-text>
                      <v-container fluid grid-list-lg>
                        <v-flex xs12 class="mt-3" v-if="messages.length > 0">
                          <message :messages="messages"></message>
                        </v-flex>
                        <v-layout row wrap>
                          <v-flex xs12>
                            <v-data-table
                              v-bind:headers="listRIOutBord"
                              v-bind:items="riOutBordItems"
                              :server-items-length="totalItemsRiOutBord"
                              :footer-props="{'items-per-page-options': itemsPerPage }"
                              v-bind:options.sync="paginationRiOutBord"
                              item-key="itemNo"
                              :loading="loading"
                              :no-data-text="noDataText"
                            >
                              <template v-slot:item="row">
                                <tr
                                  :class="{ activeRowRiOutBord: selectedRiOutBordRecord == parseInt(row.item.itemNo) }"
                                  @dblclick="doEditRiOutBord(row.item)"
                                >
                                  <td v-for="column in selectedRIOutBordColumns" :key="column">
                                    {{ row.item[column] }}
                                  </td>
                                  <td class="table-action-header">
                                    <table-action
                                      :rowData="row"
                                      review
                                      @review="doEditRiOutBord(row.item)"
                                      remove
                                      @remove="doPromptRemoveRiOutBord(row.item)"
                                      query
                                      @query="doQueryRiOutBord(row.item)"
                                    ></table-action>
                                  </td>
                                </tr>
                              </template>
                            </v-data-table>
                          </v-flex>
                        </v-layout>
                        <!--Start Delete Prompt -->
                        <confirm v-model="promptRemoveRiOutBord" @ok="doDeleteRiOutBord">
                          <p>{{ labels.promptRemoveRiOutBord }}</p>
                          <div class="queryValue">{{ deleteRiOutBord }}</div>
                        </confirm>
                        <!-- End Delete Prompt-->
                      </v-container>
                    </v-card-text>
                  </v-card>
                  <v-spacer class="mt-1"></v-spacer>
                  <v-card id="riFormCard" v-if="showRiOutBord && disableRiOutRiskPrem">
                    <v-toolbar dense color="grey lighten-5" flat>
                      <div class="v-icon mdi mdi-leaf theme--light d-flex">
                        <span class="headerTitle-b" v-if="newRiOutBord"
                          >RI Bordereaux
                          <span class="caption grey--text font-weight-light">(New)</span>
                        </span>
                        <span class="headerTitle-b" v-else-if="queryMode"
                          >RI Bordereaux
                          <span class="caption grey--text font-weight-light">(Query)</span>
                        </span>
                        <span class="headerTitle-b" v-else
                          >RI Bordereaux
                          <span class="caption grey--text font-weight-light">(Review)</span>
                        </span>
                      </div>
                      <v-spacer></v-spacer>
                      <v-btn icon @click.native="showRiOutBordDetails = !showRiOutBordDetails">
                        <v-icon primary v-if="showRiOutBordDetails">mdi-chevron-down</v-icon>
                        <v-icon primary v-else>mdi-chevron-up</v-icon>
                      </v-btn>
                    </v-toolbar>
                    <v-card-text v-if="showRiOutBordDetails">
                      <v-layout row wrap>
                        <v-flex xs6 md6 lg4 v-if="newRiOutBord">
                          <v-text-field
                            v-model="riForm.riTypeCo"
                            :label="labels.riTypeCo"
                            :data-vv-as="labels.riTypeCo"
                            v-validate="'entry'"
                            data-vv-name="riTypeCo"
                            :error-messages="errors.collect('riTypeCo')"
                            :disabled="true"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6 md6 lg4 v-else>
                          <v-subheader class="queryLabel">{{ labels.riTypeCo }}</v-subheader>
                          <div class="queryValue">{{ riForm.riTypeCo }}</div>
                        </v-flex>
                        <v-flex xs6 md6 lg4>
                          <cal-picker
                            v-model="riForm.riComDate"
                            :label="labels.riComDate"
                            :data-vv-as="labels.riComDate"
                            data-vv-name="riComDate"
                            :error-messages="errors.collect('riComDate')"
                            :disabled="true"
                          ></cal-picker>
                        </v-flex>
                        <v-flex xs6 md6 lg4>
                          <cal-picker
                            v-model="riForm.riExpDate"
                            :label="labels.riExpDate"
                            :data-vv-as="labels.riExpDate"
                            data-vv-name="riExpDate"
                            :error-messages="errors.collect('riExpDate')"
                            :disabled="true"
                          ></cal-picker>
                        </v-flex>
                        <v-flex xs6 md6 lg4 v-if="newRiOutBord">
                          <v-autocomplete
                            :items="bordItemList"
                            v-model="riForm.itemNo"
                            :label="labels.itemNo"
                            item-text="label"
                            item-value="value"
                            data-vv-name="itemNo"
                            :data-vv-as="labels.itemNo"
                            :error-messages="errors.collect('itemNo')"
                            clearable
                            v-validate="'required'"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs6 md6 lg4 v-else>
                          <v-subheader class="queryLabel">{{ labels.itemNo }}</v-subheader>
                          <div class="queryValue">{{ riForm.itemNo }}</div>
                        </v-flex>
                        <v-flex xs6 md6 lg4 v-if="newRiOutBord">
                          <v-text-field
                            v-model="riForm.cedPolNo"
                            :label="labels.cedPolNo"
                            :data-vv-as="labels.cedPolNo"
                            v-validate="'entry'"
                            data-vv-name="cedPolNo"
                            :error-messages="errors.collect('cedPolNo')"
                            :disabled="true"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6 md6 lg4 v-else>
                          <v-subheader class="queryLabel">{{ labels.cedPolNo }}</v-subheader>
                          <div class="queryValue">{{ riForm.cedPolNo }}</div>
                        </v-flex>
                        <v-flex xs6 md6 lg4></v-flex>
                        <v-flex xs1 md1 lg1>
                          <v-checkbox
                            class="align-end justify-end"
                            primary
                            hide-details
                            v-model="riForm.riSIAE"
                            :disabled="queryRiOutBord"
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs5 md5 lg3 v-if="!queryRiOutBord">
                          <v-text-field
                            v-model="riForm.riSI"
                            :label="labels.riSI"
                            :data-vv-as="labels.riSI"
                            v-validate="'entry'"
                            v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                            data-vv-name="riSI"
                            :error-messages="errors.collect('riSI')"
                            @blur="recalculateRIOutBord"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs5 md5 lg3 v-else>
                          <v-subheader class="queryLabel">{{ labels.riSI }}</v-subheader>
                          <div class="queryValue">{{ riForm.riSI }}</div>
                        </v-flex>
                        <v-flex xs6 md6 lg4 v-if="!queryRiOutBord">
                          <v-text-field
                            v-model="riForm.riSIPct"
                            :label="labels.riSIPct"
                            :data-vv-as="labels.riSIPct"
                            v-validate="'entry'"
                            v-num-mask="{ negative: true, intScale: 18, decScale: 6 }"
                            data-vv-name="riSIPct"
                            :error-messages="errors.collect('riSIPct')"
                            @blur="recalculateRIOutBord"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6 md6 lg4 v-else>
                          <v-subheader class="queryLabel">{{ labels.riSIPct }}</v-subheader>
                          <div class="queryValue">{{ riForm.riSIPct }}</div>
                        </v-flex>
                        <v-flex xs1 md1 lg1>
                          <v-checkbox
                            class="align-end justify-end"
                            primary
                            hide-details
                            v-model="riForm.riPremAE"
                            :disabled="queryRiOutBord"
                            @change="recalculateRIOutBord"
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs5 md5 lg3 v-if="!queryRiOutBord">
                          <v-text-field
                            v-model="riForm.riPrem"
                            :label="labels.riPrem"
                            :data-vv-as="labels.riPrem"
                            v-validate="'entry'"
                            v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                            data-vv-name="riPrem"
                            :error-messages="errors.collect('riPrem')"
                            :disabled="disableRiPrem"
                            @blur="recalculateRIOutBord"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs5 md5 lg3 v-else>
                          <v-subheader class="queryLabel">{{ labels.riPrem }}</v-subheader>
                          <div class="queryValue">{{ riForm.riPrem }}</div>
                        </v-flex>
                        <v-flex xs1 md1 lg1>
                          <v-checkbox
                            class="align-end justify-end"
                            primary
                            hide-details
                            v-model="riForm.riComm1AE"
                            :disabled="queryRiOutBord"
                            @change="recalculateRIOutBord"
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs5 md5 lg3 v-if="!queryRiOutBord">
                          <v-text-field
                            v-model="riForm.riComm1"
                            :label="labels.riComm1"
                            :data-vv-as="labels.riComm1"
                            v-validate="'entry'"
                            v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                            data-vv-name="riComm1"
                            :error-messages="errors.collect('riComm1')"
                            :disabled="disableRiComm1"
                            @blur="recalculateRIOutBord"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs5 md5 lg3 v-else>
                          <v-subheader class="queryLabel">{{ labels.riComm1 }}</v-subheader>
                          <div class="queryValue">{{ riForm.riComm1 }}</div>
                        </v-flex>
                        <v-flex xs1 md1 lg1>
                          <v-checkbox
                            class="align-end justify-end"
                            primary
                            hide-details
                            v-model="riForm.riComm2AE"
                            :disabled="queryRiOutBord"
                            @change="recalculateRIOutBord"
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs5 md5 lg3 v-if="!queryRiOutBord">
                          <v-text-field
                            v-model="riForm.riComm2"
                            :label="labels.riComm2"
                            :data-vv-as="labels.riComm2"
                            v-validate="'entry'"
                            v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                            data-vv-name="riComm2"
                            :error-messages="errors.collect('riComm2')"
                            :disabled="disableRiComm2"
                            @blur="recalculateRIOutBord"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs5 md5 lg3 v-else>
                          <v-subheader class="queryLabel">{{ labels.riComm2 }}</v-subheader>
                          <div class="queryValue">{{ riForm.riComm2 }}</div>
                        </v-flex>
                        <v-flex xs1 md1 lg1>
                          <v-checkbox
                            class="align-end justify-end"
                            primary
                            hide-details
                            v-model="riForm.riComm3AE"
                            :disabled="queryRiOutBord"
                            @change="recalculateRIOutBord"
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs5 md5 lg3 v-if="!queryRiOutBord">
                          <v-text-field
                            v-model="riForm.riComm3"
                            :label="labels.riComm3"
                            :data-vv-as="labels.riComm3"
                            v-validate="'entry'"
                            v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                            data-vv-name="riComm3"
                            :error-messages="errors.collect('riComm3')"
                            :disabled="disableRiComm3"
                            @blur="recalculateRIOutBord"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs5 md5 lg3 v-else>
                          <v-subheader class="queryLabel">{{ labels.riComm3 }}</v-subheader>
                          <div class="queryValue">{{ riForm.riComm3 }}</div>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                    <v-card-actions v-if="!queryRiOutBord && showRiOutBordDetails">
                      <v-spacer></v-spacer>
                      <v-btn depressed text @click.native="doAddRiOutBord = false" :loading="loading">
                        <span class="btn-normal-error">Cancel</span></v-btn
                      >
                      <v-btn depressed v-show="!queryMode" text @click.native="doSaveRiOutBord" :loading="loading">
                        <span class="btn-normal-primary">Save</span></v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog v-model="riCoDialog" width="1280px">
      <v-card>
        <v-card-title class="secondary lighten-4">
          <span class="headline">Select Company</span>
          <v-spacer></v-spacer>
          <v-btn text icon @click="riCoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-flex xs12>
            <form>
              <v-expansion-panels>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-sm>
                          <v-layout row wrap>
                            <v-flex lg6 xs12>
                              <v-text-field
                                v-on:keydown.enter.prevent="doInterFilters"
                                v-model="filters.inter"
                                :label="filtersLabel.inter"
                                :error-messages="errors.collect('inter')"
                                data-vv-name="inter"
                                :data-vv-as="filtersLabel.inter"
                                v-validate="'entry|max:100'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg6 xs12>
                              <v-text-field
                                v-on:keydown.enter.prevent="doInterFilters"
                                v-model="filters.name"
                                :label="filtersLabel.name"
                                :error-messages="errors.collect('name')"
                                data-vv-name="name"
                                :data-vv-as="filtersLabel.name"
                                v-validate="'entry|max:100'"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                      <v-card-actions right>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click.native="doClearInterFilters">Clear Filters</v-btn>
                        <v-btn color="primary" text @click.prevent="doInterFilters">Apply Filters</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </form>
          </v-flex>
          <v-flex xs12 class="mt-2">
            <v-data-table
              class="elevation-1"
              v-bind:headers="listRICo"
              v-bind:items="riCoItems"
              :server-items-length="totalItemsRiCo"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              v-bind:options.sync="paginationRiCo"
              item-key="x"
              :loading="loading"
              :no-data-text="noDataText"

            >
              <template v-slot:item="row">
                <tr>
                  <td>{{ row.item.inter }}</td>
                  <td>{{ row.item.name }}</td>
                  <td class="table-action-header">
                    <table-action :rowData="row" copy @copy="doSelectRiCo(row.item)"></table-action>
                  </td></tr
              ></template>
            </v-data-table>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="riTreatyDialog" width="1280px">
      <v-card>
        <v-card-title class="secondary lighten-4">
          <span class="headline">Select Treaty</span>
          <v-spacer></v-spacer>
          <v-btn text icon @click="riTreatyDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-flex xs12>
            <form>
              <v-expansion-panels>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-sm>
                          <v-layout row wrap>
                            <v-flex lg6 xs12>
                              <v-text-field
                                v-on:keydown.enter.prevent="doTreatyFilters"
                                v-model="filters.ttyNo"
                                :label="filtersLabel.ttyNo"
                                :error-messages="errors.collect('ttyNo')"
                                data-vv-name="ttyNo"
                                :data-vv-as="filtersLabel.ttyNo"
                                v-validate="'entry|max:100'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg6 xs12>
                              <v-text-field
                                v-on:keydown.enter.prevent="doTreatyFilters"
                                v-model="filters.ttyDesc"
                                :label="filtersLabel.ttyDesc"
                                :error-messages="errors.collect('ttyDesc')"
                                data-vv-name="ttyDesc"
                                :data-vv-as="filtersLabel.ttyDesc"
                                v-validate="'entry|max:100'"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                      <v-card-actions right>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click.native="doClearTreatyFilters">Clear Filters</v-btn>
                        <v-btn color="primary" text @click.prevent="doTreatyFilters">Apply Filters</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </form>
          </v-flex>
          <v-flex xs12 class="mt-2">
            <v-data-table
              class="elevation-1"
              v-bind:headers="listRITreaty"
              v-bind:items="riTreatyItems"
              :server-items-length="totalItemsRiTreaty"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              v-bind:options.sync="paginationRiTreaty"
              item-key="x"
              :loading="loading"
              :no-data-text="noDataText"
            >
              <template v-slot:item="row">
                <tr>
                  <td>{{ row.item.ttyNo }}</td>
                  <td>{{ row.item.ttyDesc }}</td>
                  <td class="table-action-header">
                    <table-action :rowData="row" copy @copy="doSelectRiTreaty(row.item)"></table-action>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="riAcctNoSfxDialog" width="1280px">
      <v-card>
        <v-card-title class="secondary lighten-4">
          <span class="headline">Select Account No Suffix</span>
          <v-spacer></v-spacer>
          <v-btn text icon @click="riAcctNoSfxDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-flex xs12 class="mt-2">
            <v-data-table
              class="elevation-1"
              v-bind:headers="listRIAcctNoSfx"
              v-bind:items="riAcctNoSfxItems"
              :server-items-length="totalItemsRiAcctNoSfx"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              v-bind:options.sync="paginationRiAcctNoSfx"
              item-key="x"
              :loading="loading"
              :no-data-text="noDataText"
            >
              <template v-slot:item="row">
                <tr>
                  <td>{{ row.item.acctNoSfx }}</td>
                  <td>{{ row.item.acctNoSfxDesc }}</td>
                  <td class="table-action-header">
                    <table-action :rowData="row" copy @copy="doSelectRiAcctNoSfx(row.item)"></table-action>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="riAppTxtDialog" width="50%" persistent>
      <v-card>
        <v-toolbar dense color="grey lighten-5" flat>
          <v-icon>mdi-format-align-justify</v-icon>
          <v-toolbar-title class="toolbar-title-2">{{ labels.riAppTxt }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container fluid grid-list-sm>
            <v-layout row wrap>
              <v-flex xs12>
                <v-tabs v-model="tabs" slider-color="teal">
                  <v-tab ripple :key="1">{{ labels.riAppTxt }}</v-tab>
                  <v-tab ripple :key="2">{{ labels.riAppEndtTxt }}</v-tab>
                </v-tabs>
                <v-tabs-items v-model="tabs">
                  <v-tab-item :key="1">
                    <v-card>
                      <v-card-text>
                        <v-layout row wrap>
                          <v-flex xs12>
                            <v-textarea
                              v-model="riForm.riAppTxtTemp"
                              :error-messages="errors.collect('riAppTxt')"
                              v-validate="'max:8000|entry'"
                              data-vv-validate-on="change"
                              data-vv-name="riAppTxt"
                              :data-vv-as="labels.riAppTxt"
                              :counter="8000"
                              :rows="20"
                            ></v-textarea>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item :key="2">
                    <v-card>
                      <v-card-text>
                        <v-layout row wrap>
                          <v-flex xs12>
                            <v-textarea
                              v-model="riForm.riAppEndtTxtTemp"
                              :error-messages="errors.collect('riAppEndtTxt')"
                              v-validate="'max:8000|entry'"
                              data-vv-validate-on="change"
                              data-vv-name="riAppEndtTxt"
                              :data-vv-as="labels.riAppEndtTxt"
                              :counter="8000"
                              :rows="20"
                            ></v-textarea>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed @click.native="riAppTxtDialog = false"><span class="btn-normal-error">Close</span></v-btn>
          <v-btn depressed @click="saveRiAppTxt"><span class="btn-normal-primary">Save</span></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="processingFlag" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="pa-3">
          Processing...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showErrorDialog" width="800px">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon>mdi-information</v-icon>
          <v-toolbar-title>System Information</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <div v-if="messages.length > 0" class="pb-3">
            <span class="info-dialog-msg-header">Oops something went wrong...</span>
            <v-spacer class="mt-2"></v-spacer>
              <ul class="showErrorMsgs">
                <li v-for="(error, index) in messages" :key="index">
                  {{ error.message }}
                </li>
              </ul>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    <v-dialog v-model="coinsSvcFeeDialog" width="1200px" persistent>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-toolbar-title>Coinsurance Service Fee</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn text icon @click="coinsSvcFeeDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <PolicyCoinsuranceServiceFee
            v-if="coinsSvcFeeDialog"
            ref="coinsSvcFee"
            :isDialog="true"
            @close="coinsSvcFeeDialog = false"
          ></PolicyCoinsuranceServiceFee>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import { commonMixins } from '@/mixins/common/commonMixin'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { riAjaxMixin } from '@/mixins/reinsurance/riAjaxMixin'
import { riListMixin } from '@/mixins/reinsurance/riListMixin'
import * as TableConst from '@/mixins/table'
import { removeTime } from '@/utils/date'
import isAfter from 'date-fns/isAfter'
import { POLICY_REINSURANCE_TAB, POLICY_REINSURANCE_RI_HEADER } from '@/store/types'
import { formatPrice } from '@/utils/index'
import { formatDisplayNumber, removeFormatNumber } from '@/utils/number'
import PolicyCoinsuranceServiceFee from './PolicyCoinsuranceServiceFee'
export default {
  data() {
    return {
      showErrorDialog: false,
      filters: {
        ttyNo: '',
        ttyDesc: '',
        inter: '',
        name: ''
      },
      filtersLabel: {
        ttyNo: 'Treaty No.',
        ttyDesc: 'Treaty Name',
        inter: 'Intermediary No.',
        name: 'Intermediary Name'
      },
      labels: {
        riType: 'RI Type',
        riCo: 'RI Company / Treaty',
        propXl: 'Proportional / XOL',
        acctNoSfx: 'Account No. Suffix',
        theirPolNo: 'Their Policy No.',
        cesNo: 'Cession No.',
        cesYr: 'Cession Year',
        bordEreAux: 'Bordereaux',
        prtRiApp: 'Print RI Closing',
        relRi: 'Release Now',
        tranDate: 'Transaction Date',
        riComDate: 'Commencement Date',
        riExpDate: 'Expiry Date',
        comm1Pct: 'Commission 1 %',
        comm2Pct: 'Commission 2 %',
        comm2Gn: 'Gross/Net',
        comm3Pct: 'Commission 3 %',
        comm3Gn: 'Gross/Net',
        stampDuty: 'Stamp Duty',
        riTax: 'Tax',
        riLevy: 'RI Levy',
        ccaDate: 'Acceptance Date',
        ccdDate: 'Documentation date',
        ccDateEntUsr: 'Entered By',
        ccDateRevUsr: 'Reviewed By',
        riAppTxt: 'RI Application Text',
        riAppEndtTxt: 'RI Application Endt Text',
        promptRemove: 'Are you sure you want to delete the selected RI Header?',
        promptRemoveRiOutBord: 'Are you sure you want to delete the selected RI Bordereaux?',
        cesEndtNo: 'Cession Endorsement No.',
        cesStamp: 'Cession Stamp',
        riEndtDate: 'Endorsement Date',
        billCurr: 'Billing Currency',
        docNo: 'Document No.',
        itemNo: 'Bordereaux Item',
        cedPolNo: 'Reference No.',
        riSI: 'Sum Insured',
        riSIPct: 'Sum Insured %',
        riPrem: 'RI Premium',
        riComm1: 'RI Comm 1',
        riComm2: 'RI Comm 2',
        riComm3: 'RI Comm 3',
        riTypeCo: 'RI Type - RI Company'
      },
      totalItemsRI: 0,
      paginationRI: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      riTreatyDialog: false,
      riCoDialog: false,
      riAcctNoSfxDialog: false,
      newRiHeader: false,
      newRiOutBord: false,
      editRiOutBord: false,
      queryRiOutBord: false,
      selectedRi: {},
      showRiForm: false,
      showRiOutBord: false,
      riAppTxtDialog: false,
      riForm: {
        polNo: undefined,
        renCnt: undefined,
        endtCnt: undefined,
        billCurr: undefined,
        billCurrRate: undefined,
        dept: undefined,
        cesEndtCnt: 0,
        riType: undefined,
        riCo: undefined,
        riCoDesc: undefined,
        riCoWithDesc: undefined,
        propXl: 'P',
        acctNoSfx: undefined,
        acctNoSfxDesc: undefined,
        theirPolNo: undefined,
        cesNo: undefined,
        cesYr: undefined,
        bordEreAux: false,
        prtRiApp: false,
        relRi: true,
        tranDate: undefined,
        riComDate: undefined,
        riExpDate: undefined,
        riEndtDate: undefined,
        comm1AE: undefined,
        comm1Pct: 0,
        comm2AE: false,
        comm2Pct: 0,
        comm2Gn: 'G',
        comm3AE: false,
        comm3Pct: 0,
        comm3Gn: 'G',
        stampDuty: 0,
        riTax: 0,
        riLevy: 0,
        actionName: 0,
        ccaDate: undefined,
        ccdDate: undefined,
        ccDateEntUsr: undefined,
        ccDateRevUsr: undefined,
        cesEndtNo: undefined,
        cesStamp: 0,
        docNo: undefined,
        riskGrpNo: undefined,
        riskNo: undefined,
        itemNo: undefined,
        cedPolNo: undefined,
        riSIAE: false,
        riSI: 0,
        riSIPct: 0,
        riPremAE: true,
        riPrem: 0,
        riComm1AE: true,
        riComm1: 0,
        riComm2AE: true,
        riComm2: 0,
        riComm3AE: true,
        riComm3: 0,
        riTypeCo: undefined,
        addRI: false,
        acctMth: undefined,
        acctYr: undefined,
        selectedComm: '',
        tranDateValidationMessage: undefined,
        tranDateValidation: false
      },
      promptRemove: false,
      promptRemoveRiOutBord: false,
      selectedRIHeader: undefined,
      selectedRiOutBord: undefined,
      deleteRIHeader: undefined,
      deleteRiOutBord: undefined,
      selectedRecord: '',
      selectedRiOutBordRecord: '',
      selectedRow: {},
      selectedRiOutBordRow: {},
      showRiDetails: false,
      showRiDetailForm: false,
      riDetailLabels: {
        riskDesc: 'Risk Group / No',
        riSI: 'RI Sum Insured (Amount)',
        riSIPct: 'RI Sum Insured %',
        riPrem: 'RI Premium',
        prtyLim: 'Priority Limit',
        riComm1: 'RI Commission 1',
        riComm2: 'RI Commission 2',
        riComm3: 'RI Commission 3',
        riLevy: 'RI Levy',
        riTax: 'RI Tax'
      },
      riDetailForm: {
        polNo: undefined,
        renCnt: undefined,
        cesEndtCnt: undefined,
        riType: undefined,
        riCo: undefined,
        acctNoSfx: undefined,
        riskGrpNo: undefined,
        riskNo: undefined,
        endtCnt: undefined,
        riskDesc: undefined,
        riSI: undefined,
        riSIAE: true,
        riSIPct: undefined,
        riSIPctAE: true,
        riPrem: undefined,
        riPremAE: true,
        prtyLim: undefined,
        riComm1: undefined,
        riComm1AE: true,
        riComm2: undefined,
        riComm2AE: true,
        riComm3: undefined,
        riComm3AE: true,
        riLevy: undefined,
        riLevyAE: true,
        riTax: undefined,
        riTaxAE: true,
        actionName: 0,
        riDetailSelected: undefined,
        riPremAccum: 0,
        riSIPctAccum: 0
      },
      riDetailInfo: {
        riType: undefined,
        riTypeDesc: undefined,
        riCo: undefined,
        riCoDesc: undefined,
        acctNoSfx: undefined,
        acctNoSfxDesc: undefined,
        propXl: undefined,
        propXlDesc: undefined,
        riComDate: undefined,
        riExpDate: undefined,
        riComm2Gn: undefined,
        riComm3Gn: undefined
      },
      processingFlag: false,
      disableRiPrem: false,
      disableRiComm1: true,
      disableRiComm2: true,
      disableRiComm3: true,
      disableRiOutRiskPrem: false,
      showRiOutBordDetails: true,
      bordItemList: [],
      coinsSvcFeeDialog: false,
      showCoinsSvcFeeBtn: false,
      checkContractCertaintyDisplay: true,
      tabs: [],
      acctNoSfxMapData_6: {},
      acctNoSfxMapData_5: {},
      acctNoSfxMapList: {},
      dri_: '',
      acctNoSfxApplnInt_: 0,
      riHeaderDisplay: '',
      defCesYr: 0,
      uwYr: 0,
      billCurrDesc: '',
      miscparams: {}
    }
  },
  methods: {
    async doInit() {
      if ((this.polMaster.appCoIns && parseInt(this.polMaster.billCoIns) === 1) || (this.polMaster.appCoIns && this.polMaster.billCoIns === 'Y')) {
        this.showCoinsSvcFeeBtn = true
      }
      await Promise.all([this.$store.dispatch('riOutInit')])
      await this.$store.dispatch('riOutListingInit')
      await this.$store.dispatch('riAutoCessionInit')
      await this.doGetCesYr(this.polMaster.polNo, this.polMaster.renCnt, this.polMaster.endtCnt)
      await this.getRiOutMasterList()
      this.dri_ = this.polMaster.dri === true ? 'D' : 'R'
      this.acctNoSfxApplnInt_ = 6
      if (this.$store.state.commons.init === 0) {
        await this.$store.dispatch('commonsInit')
      }
      await this.getCommonData('acctnosfxmap_applnint_dri', this.acctNoSfxApplnInt_ + ',' + this.dri_)
      this.acctNoSfxApplnInt_ = 5
      await this.getCommonData('acctnosfxmap_applnint_dri', this.acctNoSfxApplnInt_ + ',' + this.dri_)
      await this.getCommonData('miscparams')
    },
    assignAcctNoSfxMapApplIntDri(data) {
      if (this.acctNoSfxApplnInt_ === 6) {
        this.acctNoSfxMapData_6 = data
      } else if (this.acctNoSfxApplnInt_ === 5) {
        this.acctNoSfxMapData_5 = data
      }
    },
    getRIType(key) {
      for (let riType of this.riTypeList) {
        if (riType.value === key) {
          return riType
        }
      }
      return ''
    },
    openRiAppTxt() {
      this.riForm.riAppTxtTemp = this.riForm.riAppTxt
      this.riForm.riAppEndtTxtTemp = this.riForm.riAppEndtTxt
      this.riAppTxtDialog = true
    },
    saveRiAppTxt() {
      this.riForm.riAppTxt = this.riForm.riAppTxtTemp
      this.riForm.riAppEndtTxt = this.riForm.riAppEndtTxtTemp
      this.riAppTxtDialog = false
    },
    async getRiOutMasterList() {
      this.selectedRi.polNo = this.polMaster.polNo
      this.selectedRi.renCnt = this.polMaster.renCnt
      this.selectedRi.endtCnt = this.polMaster.endtCnt
      this.selectedRi.comDate = this.polMaster.comDate
      this.selectedRi.expDate = this.polMaster.expDate
      this.selectedRi.tranDate = this.polMaster.tranDate
      this.selectedRi.riskGrpNo = this.riForm.riskGrpNo
      this.selectedRi.riskNo = this.riForm.riskNo
      this.doFetch(false).then(() => {
        if (this.prevRel) {
          this.stepForm.step = 4
          this.$router.push({ name: 'policySummary' })
        }
        if (this.riHeaderItems.length > 0) {
          this.doEdit(this.riHeaderItems[0])
        } else {
          this.checkPolBordItem(this.selectedRi).then((result) => {
          })
        }
      })
    },
    doAdd() {
      this.newRiHeader = true
      this.riForm.addRI = true
      this.riForm.selectedComm = ''
      this.riHeaderDisplay = ''

      this.riForm.polNo = this.polMaster.polNo
      this.riForm.renCnt = this.polMaster.renCnt
      this.riForm.endtCnt = this.polMaster.endtCnt
      this.riForm.tranDate = this.polMaster.tranDate
      this.riForm.riComDate = this.polMaster.comDate
      this.riForm.riExpDate = this.polMaster.expDate
      this.riForm.riskGrpNo = this.selectedRiskGrpNo
      this.riForm.riskNo = this.selectedRiskNo
      this.riForm.riType = undefined
      this.riForm.riCoDesc = undefined
      this.riForm.riCo = undefined
      this.riForm.riCoWithDesc = undefined
      this.riForm.propXl = 'P'
      this.riForm.acctNoSfx = undefined
      this.riForm.acctNoSfxDesc = undefined
      this.riForm.theirPolNo = undefined
      this.riForm.cesNo = undefined
      this.riForm.cesYr = this.defCesYr ? this.uwYr : removeTime((this.selectedRi || {}).tranDate).getFullYear()
      this.riForm.bordEreAux = false
      this.riForm.prtRiApp = false
      this.riForm.relRi = true
      this.riForm.comm1AE = false
      this.riForm.comm1Pct = formatDisplayNumber(0, 6)
      this.riForm.comm2AE = false
      this.riForm.comm2Pct = formatDisplayNumber(0, 6)
      this.riForm.comm2Gn = 'G'
      this.riForm.comm3AE = false
      this.riForm.comm3Pct = formatDisplayNumber(0, 6)
      this.riForm.comm3Gn = 'G'
      this.riForm.stampDuty = 0
      this.riForm.riTax = 0
      this.riForm.riLevy = 0
      this.riForm.ccaDate = undefined
      this.riForm.ccdDate = undefined
      this.riForm.riAppTxt = undefined
      this.riForm.riAppEndtTxt = undefined
      this.riForm.riAppTxtTemp = undefined
      this.riForm.riAppEndtTxtTemp = undefined

      // LYT 2020-12-22 OS-618
      this.riForm.cesEndtNo = undefined
      this.riForm.cesStamp = formatPrice(0)
      this.riForm.riEndtDate = this.polMaster.endtDate
      this.riForm.docNo = ''
      this.riForm.billCurr = this.polMaster.billCurr + ' - ' + this.billCurrDesc
      this.showRiForm = true
      this.$nextTick(() => {
        this.$vuetify.goTo('#riFormCard')
      })
      this.resetActiveRow()
      this.resetRiDetails()
    },
    async doAddRiOutBord() {
      this.newRiOutBord = true
      this.editRiOutBord = false
      this.queryRiOutBord = false
      this.doFetchRiOutBordItem(this.riForm).then(() => {
        this.riForm.riTypeCo = this.riForm.riType + ' / ' + this.riForm.riCo + ' - ' + this.riForm.riCoDesc
        this.riForm.cedPolNo = undefined
        this.riForm.riSIAE = false
        this.riForm.riSI = 0
        this.riForm.riSIPct = 0
        this.riForm.riPremAE = true
        this.riForm.riPrem = 0
        this.riForm.riComm1AE = true
        this.riForm.riComm1 = 0
        this.riForm.riComm2AE = true
        this.riForm.riComm2 = 0
        this.riForm.riComm3AE = true
        this.riForm.riComm3 = 0

        this.showRiOutBord = true
      })
    },
    async doEdit(data) {
      this.riHeaderDisplay = data.riType + ' / ' + data.riCo + ' / ' + data.acctNoSfx + ' -'
      this.newRiHeader = false
      this.riForm.addRI = false
      this.resetMessages()
      this.showRiForm = false
      this.activateRow(data)
      this.newRiOutBord = false
      this.editRiOutBord = true
      this.queryRiOutBord = false
      await this.doFetchRiHeader(data).then(() => {
        this.riForm.cesYr = this.defCesYr ? this.uwYr : removeTime((this.selectedRi || {}).tranDate).getFullYear()
        this.doAcctNoSfxInit()
        this.contractCertaintyDisplayChanged()
      })
    },
    contractCertaintyDisplayChanged() {
      if (this.riForm.bordEreAux) {
        if (this.riForm.riType !== 'F') {
          this.checkContractCertaintyDisplay = false
        } else {
          this.checkContractCertaintyDisplay = false
        }
      } else {
        this.checkContractCertaintyDisplay = true
      }
      if (this.riForm.riType !== 'F') {
        this.checkContractCertaintyDisplay = false
      }
      this.doShowRiDetails()
    },
    async doEditRiOutBord(data) {
      this.resetMessages()
      this.activeRowRiOutBord(data)
      this.newRiOutBord = false
      this.editRiOutBord = true
      this.queryRiOutBord = false
      await this.doFetchRiOutBord(data)
      this.changeRiPremAE()
      this.changeRiCommAE()
    },
    async doQueryRiOutBord(data) {
      this.resetMessages()
      this.showRiOutBord = true
      this.activeRowRiOutBord(data)
      this.newRiOutBord = false
      this.editRiOutBord = false
      this.queryRiOutBord = true
      await this.doFetchRiOutBord(data)
    },
    doAmend(riData) {
      this.$store.commit(POLICY_REINSURANCE_TAB, 1)
      this.$store.commit(POLICY_REINSURANCE_RI_HEADER, riData)
      this.$router.push({ name: 'policyReinsuranceDetail' })
    },
    async RISaveAndExit() {
      var success = false
      this.processingFlag = true
      const apiURI = this.$store.state.reinsurance.riOutListing.menu.saveAndExit
      if (apiURI) {
        try {
          let result
          this.riDetailForm.riSI = removeFormatNumber(this.riDetailForm.riSI)
          this.riDetailForm.riSIPct = removeFormatNumber(this.riDetailForm.riSIPct)
          this.riDetailForm.riPrem = removeFormatNumber(this.riDetailForm.riPrem)
          this.riDetailForm.prtyLim = removeFormatNumber(this.riDetailForm.prtyLim)
          this.riDetailForm.riComm1 = removeFormatNumber(this.riDetailForm.riComm1)
          this.riDetailForm.riComm2 = removeFormatNumber(this.riDetailForm.riComm2)
          this.riDetailForm.riComm3 = removeFormatNumber(this.riDetailForm.riComm3)
          this.riDetailForm.riLevy = removeFormatNumber(this.riDetailForm.riLevy)
          this.riDetailForm.riTax = removeFormatNumber(this.riDetailForm.riTax)
          if (this.newRiHeader === false) {
            this.riForm.actionName = 'RI_HEADER_UPDATE'
          } else {
            this.riForm.actionName = 'RI_HEADER_CREATE'
          }
          const expand = {
            polNo: this.riForm.polNo,
            renCnt: this.riForm.renCnt,
            endtCnt: this.riForm.endtCnt,
            billCurr: this.riForm.billCurr,
            billCurrRate: this.riForm.billCurrRate,
            dept: this.riForm.dept,
            cesEndtCnt: this.riForm.cesEndtCnt,
            riType: this.riForm.riType,
            riCo: this.riForm.riCo,
            riCoDesc: this.riForm.riCoDesc,
            propXl: this.riForm.propXl,
            acctNoSfx: this.riForm.acctNoSfx,
            acctNoSfxDesc: this.riForm.acctNoSfxDesc,
            theirPolNo: this.riForm.theirPolNo,
            cesNo: this.riForm.cesNo,
            cesYr: this.riForm.cesYr,
            bordEreAux: this.riForm.bordEreAux,
            prtRiApp: this.riForm.prtRiApp,
            relRi: this.riForm.relRi,
            tranDate: this.riForm.tranDate,
            riComDate: this.riForm.riComDate,
            riExpDate: this.riForm.riExpDate,
            riEndtDate: this.riForm.riEndtDate,
            comm1AE: this.riForm.comm1AE,
            comm1Pct: this.riForm.comm1Pct,
            comm2AE: this.riForm.comm2AE,
            comm2Pct: this.riForm.comm2Pct,
            comm2Gn: this.riForm.comm2Gn,
            comm3AE: this.riForm.comm3AE,
            comm3Pct: this.riForm.comm3Pct,
            comm3Gn: this.riForm.comm3Gn,
            stampDuty: this.riForm.stampDuty,
            riTax: this.riForm.riTax,
            riLevy: this.riForm.riLevy,
            actionName: this.riForm.actionName,
            ccaDate: this.riForm.ccaDate,
            ccdDate: this.riForm.ccdDate,
            ccDateEntUsr: this.riForm.ccDateEntUsr,
            ccDateRevUsr: this.riForm.ccDateRevUsr,
            cesEndtNo: this.riForm.cesEndtNo,
            cesStamp: this.riForm.cesStamp,
            docNo: this.riForm.docNo,
            riskGrpNo: this.riDetailForm.riskGrpNo,
            riskNo: this.riDetailForm.riskNo,
            cedPolNo: this.riForm.cedPolNo,
            riSIAE: this.riDetailForm.riSIAE,
            riSI: this.riDetailForm.riSI,
            riSIPctAE: this.riDetailForm.riSIPctAE,
            riSIPct: this.riDetailForm.riSIPct,
            riPremAE: this.riDetailForm.riPremAE,
            riPrem: this.riDetailForm.riPrem,
            riComm1AE: this.riDetailForm.riComm1AE,
            riComm1: this.riDetailForm.riComm1,
            riComm2AE: this.riDetailForm.riComm2AE,
            riComm2: this.riDetailForm.riComm2,
            riComm3AE: this.riDetailForm.riComm3AE,
            riComm3: this.riDetailForm.riComm3,
            riTaxDet: this.riDetailForm.riTax,
            riLevyDet: this.riDetailForm.riLevy,
            prtyLim: this.riDetailForm.prtyLim,
            riTypeCo: this.riForm.riTypeCo,
            addRI: this.riForm.addRI,
            acctMth: this.riForm.acctMth,
            acctYr: this.riForm.acctYr,
            riLevyAE: this.riDetailForm.riLevyAE,
            riTaxAE: this.riDetailForm.riTaxAE,
            selectedComm: this.riForm.selectedComm
          }
          result = await this.$http.post(apiURI, expand)
          const { data } = result
          if (data) {
            success = true
            this.processingFlag = false
          }
          success = true
          this.processingFlag = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.processingFlag = false
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
        this.processingFlag = true
      }
      return success
    },
    async doSaveRiHeader() {
      this.resetMessages()
      if (this.newRiHeader === false) {
        this.$validator.validateAll().then((success) => {
          if (success) {
            this.processingFlag = true
            this.riForm.actionName = 'RI_HEADER_UPDATE'
            this.performAction().then((success) => {
              if (success) {
                this.showRiForm = false
                this.getRiOutMasterList()
                if ((this.riForm.riType === 'F' || this.riForm.riType === 'T')) {
                  if (this.riOutBordItems.length > 0) {
                    this.updateRiOutBord().then((riOutBord) => {
                      if (riOutBord !== false) {
                        this.doFetchRiOutBordList(riOutBord)
                      }
                    })
                  }
                }
              }
              this.processingFlag = false
            })
          } else {
            this.promptFieldCheck()
            this.processingFlag = false
          }
        })
      } else {
        this.$validator.validateAll().then((success) => {
          if (success) {
            this.riForm.actionName = 'RI_HEADER_CREATE'
            this.performAction().then((result) => {
              if (result) {
                this.selectedRow = this.riForm
                this.processingFlag = false
                if (this.newRiHeader && (this.riForm.riType === 'F' || this.riForm.riType === 'T')) {
                  this.createRiOutBord().then((riOutBord) => {
                    if (riOutBord !== false) {
                      this.doFetchRiOutBordList(riOutBord)
                      this.doEdit(this.selectedRow)
                    } else {
                      this.doEdit(this.selectedRow)
                    }
                  })
                }
              }
            })
          } else {
            this.promptFieldCheck()
            this.processingFlag = false
          }
        })
      }
    },
    async doSaveRiOutBord() {
      this.resetMessages()
      this.processingFlag = true
      if (this.newRiOutBord === false) {
        this.updateRiOutBord().then((result) => {
          if (result) {
            this.processingFlag = false
            this.doFetchRiOutBordList(this.riDetailForm)
          }
        })
      } else {
        this.$validator.validateAll().then((success) => {
          if (success) {
            this.createRiOutBord().then((result) => {
              if (result) {
                this.selectedRiOutBordRow = this.riForm
                this.doEditRiOutBord(this.selectedRiOutBordRow)
                this.processingFlag = false
                this.doFetchRiOutBordList(this.riDetailForm)
              }
            })
          } else {
            this.promptFieldCheck()
            this.processingFlag = false
          }
        })
      }
    },
    bordEreAuxChanged() {
      if (this.riForm.bordEreAux) {
        if (this.riForm.riType !== 'F') {
          this.checkContractCertaintyDisplay = false
        } else {
          this.checkContractCertaintyDisplay = false
        }
        this.riForm.ccaDate = undefined
        this.riForm.ccdDate = undefined
      } else {
        this.checkContractCertaintyDisplay = true
      }
      this.doShowRiDetails()
    },
    checkRiType() {
      if (this.newRiHeader === true) {
        this.doAcctNoSfxInit()
        this.riForm.riCoDesc = undefined
        this.riForm.riCo = undefined
        this.riForm.riCoWithDesc = undefined
        this.riForm.propXl = 'P'
        this.riForm.acctNoSfx = undefined
        this.riForm.acctNoSfxDesc = undefined
        this.riForm.theirPolNo = undefined
        this.riForm.cesNo = undefined
        this.riForm.cesYr = this.defCesYr ? this.uwYr : removeTime((this.selectedRi || {}).tranDate).getFullYear()
        this.riForm.bordEreAux = false
        this.riForm.prtRiApp = false
        this.riForm.relRi = true
        this.riForm.comm1AE = false
        this.riForm.comm1Pct = formatDisplayNumber(0, 6)
        this.riForm.comm2AE = false
        this.riForm.comm2Pct = formatDisplayNumber(0, 6)
        this.riForm.comm2Gn = 'G'
        this.riForm.comm3AE = false
        this.riForm.comm3Pct = formatDisplayNumber(0, 6)
        this.riForm.comm3Gn = 'G'
        this.riForm.stampDuty = 0
        this.riForm.riTax = 0
        this.riForm.riLevy = 0
        this.riForm.tranDate = this.polMaster.tranDate
        if (this.riForm.riType === 'D') {
          // [riOutMaster.riCo] = 'STAT'
          this.riForm.riCo = 'STAT'
          this.riForm.riCoDesc = 'STAT'
          // [riOutMaster.acctNoSfx] = Blank
          this.riForm.acctNoSfx = ''
          // [riOutMaster.propXL] = Blank
          this.riForm.propXl = 'P'
          if (this.newRiHeader) {
            this.riForm.riComm1AE = false
            this.riForm.riComm2AE = false
            this.riForm.riComm3AE = false
            this.disableRiBord = true
          }
          this.changeRiCo()
        } else if (this.riForm.riType === 'C') {
          this.riForm.comm1AE = true
          this.riForm.propXl = 'P'
          if (this.acctNoSfxMapData_6) {
            this.riForm.acctNoSfx = this.acctNoSfxMapData_6.acctNoSfx
          } else {
            this.riForm.acctNoSfx = ''
          }
          if (this.newRiHeader) {
            this.riForm.riComm1AE = true
            this.riForm.riComm2AE = false
            this.riForm.riComm3AE = false
            this.disableRiBord = true
            this.changeRiCo()
          }
          this.dri_ = this.polMaster.dri === true ? 'D' : 'R'
          this.acctNoSfxInit(6, this.dri_)
        } else if (this.riForm.riType === 'F') {
          this.riForm.comm1AE = true
          if (this.acctNoSfxMapData_5) {
            this.riForm.acctNoSfx = this.acctNoSfxMapData_5.acctNoSfx
          } else {
            this.riForm.acctNoSfx = ''
          }
          if (this.newRiHeader) {
            this.riForm.riComm1AE = true
            this.riForm.riComm2AE = false
            this.riForm.riComm3AE = false
            this.disableRiBord = false
          }
          this.changeRiCo()
          this.dri_ = this.polMaster.dri === true ? 'D' : 'R'
          this.acctNoSfxInit(5, this.dri_)
        } else if (this.riForm.riType === 'W') {
          if (this.newRiHeader) {
            this.riForm.prtRiApp = false
            this.disableRiBord = true
          }
          this.changeRiCo()
        } else {
          this.riForm.acctNoSfxDesc = undefined
          this.riForm.acctNoSfx = undefined
          this.riForm.propXl = 'P'
          this.disableRiBord = true
        }
      }
    },
    doShowRiCo() {
      if (this.riForm.riType === 'T' || this.riForm.riType === 'W') {
        this.riTreatyDialog = true
        this.doClearTreatyFilters()
      } else if (this.riForm.riType === 'C' || this.riForm.riType === 'D' || this.riForm.riType === 'F') {
        this.riCoDialog = true
        this.doClearInterFilters()
      }
    },
    doShowAcctNoSfx() {
      if (this.riForm.riType === 'C') {
        this.riAcctNoSfxDialog = true
        this.riAcctNoSfxInit(6)
      } else if (this.riForm.riType === 'F') {
        this.riAcctNoSfxDialog = true
        this.riAcctNoSfxInit(5)
      }
    },
    doAcctNoSfxInit() {
      if (this.riForm.riType === 'C') {
        this.riAcctNoSfxInit(6)
      } else if (this.riForm.riType === 'F') {
        this.riAcctNoSfxInit(5)
      }
    },
    async doDelete() {
      const apiURI = this.$store.state.reinsurance.riOutListing.menu.deleteRiHeader
      if (apiURI) {
        const expand = this.selectedRIHeader
        await this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.doInit()
            this.riHeaderDisplay = ''
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    },
    async doDeleteRiOutBord() {
      const apiURI = this.$store.state.reinsurance.riOutListing.menu.deleteRiOutBord
      if (apiURI) {
        this.selectedRiOutBord.riSI = removeFormatNumber(this.selectedRiOutBord.riSI)
        this.selectedRiOutBord.riSIPct = removeFormatNumber(this.selectedRiOutBord.riSIPct)
        this.selectedRiOutBord.riPrem = removeFormatNumber(this.selectedRiOutBord.riPrem)
        this.selectedRiOutBord.riComm1 = removeFormatNumber(this.selectedRiOutBord.riComm1)
        this.selectedRiOutBord.riComm2 = removeFormatNumber(this.selectedRiOutBord.riComm2)
        this.selectedRiOutBord.riComm3 = removeFormatNumber(this.selectedRiOutBord.riComm3)
        const expand = this.selectedRiOutBord
        await this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.doFetchRiOutBordList(this.riDetailForm).then((result) => {
              if (result !== false) {
                this.doEditRiOutBord(this.riOutBordItems[0])
              } else {
                this.resetRiOutBord()
              }
            })
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    },
    resetRiOutBord() {
      this.riForm.itemNo = undefined
      this.riForm.cedPolNo = undefined
      this.riForm.riSIAE = false
      this.riForm.riSI = 0
      this.riForm.riSIPct = 0
      this.riForm.riPremAE = true
      this.riForm.riPrem = 0
      this.riForm.riComm1AE = true
      this.riForm.riComm1 = 0
      this.riForm.riComm2AE = true
      this.riForm.riComm2 = 0
      this.riForm.riComm3AE = true
      this.riForm.riComm3 = 0
      this.riForm.riTypeCo = undefined
    },
    changeRiPremAE() {
      if (this.riForm.riPremAE) {
        this.disableRiPrem = true
      } else {
        this.disableRiPrem = false
      }
    },
    changeRiComm1AE() {
      if (this.riForm.riComm1AE) {
        this.disableRiComm1 = true
      } else {
        this.disableRiComm1 = false
      }
      if (this.riForm.riComm2AE) {
        this.disableRiComm2 = true
      } else {
        this.disableRiComm2 = false
      }
      if (this.riForm.riComm3AE) {
        this.disableRiComm3 = true
      } else {
        this.disableRiComm3 = false
      }
    },
    changeRiCommAE() {
      if (this.riForm.riComm1AE) {
        this.disableRiComm1 = true
      } else {
        this.disableRiComm1 = false
      }
      if (this.riForm.riComm2AE) {
        this.disableRiComm2 = true
      } else {
        this.disableRiComm2 = false
      }
      if (this.riForm.riComm3AE) {
        this.disableRiComm3 = true
      } else {
        this.disableRiComm3 = false
      }
    },
    doPromptRemove(item) {
      this.promptRemove = true
      this.labels.promptRemove = 'You have chosen to delete this ' + item.riCo + ' record. Do you really want to delete this record?'
      this.selectedRIHeader = item
      this.deleteRIHeader = item.riType + ' - ' + item.riCo
    },
    doPromptRemoveRiOutBord(item) {
      this.promptRemoveRiOutBord = true
      this.labels.promptRemoveRiOutBord =
        'You have chosen to delete this Item No. ' + item.itemNo + ' record. Do you really want to delete this record?'
      this.selectedRiOutBord = item
      this.deleteRiOutBord = 'Item No.: ' + item.itemNo
    },
    resetActiveRow() {
      const rows = Array.from(document.querySelectorAll('tr.activeRow'))
      rows.forEach((row) => {
        row.classList.remove('activeRow')
      })
      this.selectedRecord = {}
    },
    resetActiveRowRiOutBord() {
      const rows = Array.from(document.querySelectorAll('tr.activeRowRiOutBord'))
      rows.forEach((row) => {
        row.classList.remove('activeRowRiOutBord')
      })
      this.selectedRiOutBordRecord = {}
    },
    resetRiDetails() {
      this.showRiDetails = false
      this.showRiDetailForm = false
      this.showRiForm = true
      this.riDetailItems = []
      this.riOutBordItems = []
      this.doCancelDetail()
    },
    doCancelDetail() {
      if (this.newRiHeader === true) {
        this.riDetailForm.riskGrpNo = undefined
        this.riDetailForm.riskNo = undefined
        this.riDetailForm.riskDesc = undefined
        this.riDetailForm.riSI = undefined
        this.riDetailForm.riSIAE = true
        this.riDetailForm.riSIPct = undefined
        this.riDetailForm.riSIPctAE = true
        this.riDetailForm.riPrem = undefined
        this.riDetailForm.riPremAE = true
        this.riDetailForm.prtyLim = undefined
        this.riDetailForm.riComm1AE = true
        this.riDetailForm.riComm1 = undefined
        this.riDetailForm.riComm2AE = true
        this.riDetailForm.riComm2 = undefined
        this.riDetailForm.riComm3AE = true
        this.riDetailForm.riComm3 = undefined
        this.riDetailForm.riTax = undefined
        this.riDetailForm.riTaxAE = true
        this.riDetailForm.riLevy = undefined
        this.riDetailForm.riLevyAE = true
        this.riDetailPanel = false
      } else {
        this.showRiDetailForm = false
      }
    },
    doShowRiDetails() {
      if (!this.showRiOutBord) {
        this.showRiDetails = true
      } else {
        this.showRiDetails = false
      }
      this.doReview(this.selectedRow).then(() => {
        if (this.riDetailItems.length > 0) {
          this.doDetailEdit(this.riDetailItems[0])
        }
        if (this.selectedRow.riType === 'C') {
          this.dri_ = this.polMaster.dri === true ? 'D' : 'R'
          this.acctNoSfxInit(6, this.dri_)
        } else if (this.selectedRow.riType === 'F') {
          this.dri_ = this.polMaster.dri === true ? 'D' : 'R'
          this.acctNoSfxInit(5, this.dri_)
        }
      })
    },
    doShowRiOutBordDetails() {
      this.showRiOutBord = true
      this.doRiOutBordReview(this.selectedRiOutBordRow).then(() => {
        if (this.riOutBordItems.length > 0) {
          this.doRiOutBordDetailEdit(this.riOutBordItems[0])
        }
      })
    },
    activateRow(props) {
      this.selectedRecord = props.riType + '-' + props.riCoDesc + '-' + props.acctNoSfx
      this.selectedRow = props
    },
    activeRowRiOutBord(props) {
      this.selectedRiOutBordRecord = parseInt(props.itemNo)
    },
    doReviewDetails(data) {
      this.showRiDetailForm = true
      this.doDetailEdit(data)
      this.$nextTick(() => {
        this.$vuetify.goTo('#riDetailFormCard')
      })
    },
    doReviewRiOutBordDetails(data) {
      this.doRiOutBordDetailEdit(data)
    },
    async doDetailEdit(riDetail) {
      this.selectedRi.riskGrpNo = riDetail.riskGrpNo
      this.selectedRi.riskNo = riDetail.riskNo
      await this.doFetchRiDetail(riDetail).then((result1) => {
        if (result1) {
          this.doFetchRiOutBordList(this.riDetailForm).then((result) => {
            if (result === false) {
              this.resetRiOutBord()
            } else {
              if (this.riOutBordItems.length > 0) {
                this.showRiOutBord = true
                this.doEditRiOutBord(this.riOutBordItems[0])
              } else {
                this.showRiOutBord = false
              }
            }
          })
        }
      })
    },
    doRiOutBordDetailEdit(riDetail) {
      this.doFetchRiOutBord(riDetail)
    },
    doSaveRiDetail() {
      this.$validator.validateAll().then((success) => {
        if (success) {
          this.resetMessages()
          this.processingFlag = true
          this.riDetailForm.actionName = 'RI_DETAIL_UPDATE'
          this.riDetailSave().then((result) => {
            if (result) {
              this.showRiDetailForm = false
            }
            this.processingFlag = false
          })
        }
      })
    },
    formatDisplayNumber(xNum) {
      return formatDisplayNumber(xNum)
    },
    formatMoney(val) {
      return formatPrice(val)
    },
    getBordItem() {
    },
    async performAutoCession() {
      const apiURI = this.$store.state.reinsurance.riAutoCession.menu.performAction
      if (apiURI) {
        try {
          this.autocessionProcessing = true
          const requestForm = {
            // Require input: PolNo, RenCnt, EndtCnt, PolScheme
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt,
            polScheme: this.polMaster.scheme,
            actionName: 'FROM_POLICY_SUMMARY'
          }
          const result = await this.$http.post(apiURI, requestForm)
          const { data } = result
          if (data) {
            this.notify(data)
            // this.$toast.success('RI Auto Cession Success.')
            this.$refs.sumInsuredTotals.doInit()
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
      this.autocessionProcessing = false
    },
    async doGetCesYr(polNo, renCnt, endtCnt) {
      const expand = {
        polNo: polNo,
        renCnt: renCnt,
        endtCnt: endtCnt
      }
      const apiURI = this.$store.state.reinsurance.riOutListing.menu.getCesYrInfo
      if (apiURI) {
        try {
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result) {
            this.defCesYr = result.data.data.defCesYr
            this.uwYr = result.data.data.uwYr
            this.billCurrDesc = result.data.data.billCurrDesc
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    }
  },
  computed: {
    polMaster() {
      return this.$store.state.underwriting.policy.polMaster
    },
    selectedRiskGrpNo() {
      return this.$store.state.underwriting.policy.selectedRiskGrpNo
    },
    selectedRiskNo() {
      return this.$store.state.underwriting.policy.selectedRiskNo
    },
    tranDateValidation() {
      const result = 'required|riHeader_tranDate:' + this.riForm.tranDateValidationMessage + ',' + this.riForm.tranDateValidation
      return result
    },
    comDateValidation() {
      if (this.polMaster.comDate === null || this.polMaster.comDate === undefined) {
        if (this.polMaster.expDate !== null) {
          return 'riHeader_expDate:' + this.polMaster.expDate
        } else {
          return ''
        }
      } else {
        const result = 'required|riHeader_comDate:' + this.selectedRi.comDate + '|riHeader_expDate:' + this.selectedRi.expDate
        return result
      }
    },
    expDateValidation() {
      if (this.polMaster.expDate !== null) {
        return 'required|riHeaderEndt_expDate:' + this.polMaster.expDate
      } else if (this.polMaster.comDate === null || this.polMaster.comDate === undefined) {
        return ''
      } else {
        const result = 'required|riHeader_comDate:' + this.selectedRi.comDate + '|riHeader_expDate:' + this.selectedRi.expDate
        return result
      }
    },
    endtDateValidation() {
      const result = 'required|riHeaderEndt_comDate:' + this.riForm.riComDate + '|riHeaderEndt_expDate:' + this.riForm.riExpDate
      return result
    },
    treatyRiCoValidation() {
      const result = 'required|treaty_riCo_validate:' + this.errors.collect('riCo')
      return result
    },
    riSIPctValidation() {
      const result = 'required|riSIPct_validate:' + this.riDetailForm.riSIPctAccum
      return result
    },
    getRIPremiumTotal() {
      if (this.riDetailItems.length > 0) {
        return formatDisplayNumber(this.riDetailItems[0].riPremAccum)
      } else {
        return formatDisplayNumber(0)
      }
    },
    getRIComm1Total() {
      if (this.riDetailItems.length > 0) {
        return formatDisplayNumber(this.riDetailItems[0].riComm1Accum)
      } else {
        return formatDisplayNumber(0)
      }
    },
    getRIComm2Total() {
      if (this.riDetailItems.length > 0) {
        return formatDisplayNumber(this.riDetailItems[0].riComm2Accum)
      } else {
        return formatDisplayNumber(0)
      }
    },
    getRIComm3Total() {
      if (this.riDetailItems.length > 0) {
        return formatDisplayNumber(this.riDetailItems[0].riComm3Accum)
      } else {
        return formatDisplayNumber(0)
      }
    },
    getRINetPremTotal() {
      if (this.riDetailItems.length > 0) {
        return formatDisplayNumber(this.riDetailItems[0].riNetPremAccum)
      } else {
        return formatDisplayNumber(0)
      }
    },
    getRILevyTotal() {
      if (this.riDetailItems.length > 0) {
        return formatDisplayNumber(this.riDetailItems[0].riLevyAccum)
      } else {
        return formatDisplayNumber(0)
      }
    },
    getRITaxTotal() {
      if (this.riDetailItems.length > 0) {
        return formatDisplayNumber(this.riDetailItems[0].riTaxAccum)
      } else {
        return formatDisplayNumber(0)
      }
    },
    riTypeValidation() {
      const result = 'required' +
      '|riType_C_AppCoins_validate:' + this.polMaster.appCoIns +
      '|riType_C_BillCoins_validate:' + this.polMaster.billCoIns
      return result
    },
    riTypeFaculativeValidate() {
      const result = (this.riForm.riType === 'F') ? 'required' : ''
      return result
    },
    displayErrorDialog() {
      return this.messages
    },
    stepForm() {
      return this.$store.state.underwriting.policy.stepForm
    }
  },
  created() {
    this.$validator.extend('riHeader_tranDate', {
      getMessage(field, args) {
        var tranMessage = args[0]
        return `${tranMessage}`
      },
      validate(value, args) {
        if (value) {
          var comDate = args[1]
          if (comDate === 'true' && args[0] !== undefined) {
            return false
          } else return true
        } else return true
      }
    })
    this.$validator.extend('riHeader_comDate', {
      getMessage(field, args) {
        return `RI ${field} cannot be earlier than Policy's Commencement Date (10201)`
      },
      validate(value, args) {
        if (value) {
          if (args === void 0) args = []
          var comDate = args[0]
          if (comDate) {
            return !isAfter(removeTime(comDate), removeTime(value))
          } else return true
        } else return true
      }
    })
    this.$validator.extend('riHeader_expDate', {
      getMessage(field, args) {
        return `RI ${field} cannot be later than Policy's Expiry Date (20256)`
      },
      validate(value, args) {
        if (value) {
          if (args === void 0) args = []
          var expDate = args[0]
          if (expDate) {
            return !isAfter(removeTime(value), removeTime(expDate))
          } else return true
        } else return true
      }
    })
    this.$validator.extend('riHeaderEndt_comDate', {
      getMessage(field, args) {
        return `RI ${field} cannot be earlier than Commencement Date. (10008)`
      },
      validate(value, args) {
        if (value) {
          if (args === void 0) args = []
          var comDate = args[0]
          if (comDate) {
            return !isAfter(removeTime(comDate), removeTime(value))
          } else return true
        } else return true
      }
    })
    this.$validator.extend('riHeaderEndt_expDate', {
      getMessage(field, args) {
        return `RI ${field} cannot be later than Expiry Date. (10109)`
      },
      validate(value, args) {
        if (value) {
          if (args === void 0) args = []
          var expDate = args[0]
          if (expDate) {
            return !isAfter(removeTime(value), removeTime(expDate))
          } else return true
        } else return true
      }
    })
    this.$validator.extend('claims_Date_today', {
      getMessage(field, args) {
        return `The ${field} cannot be later than Today.`
      },
      validate(value, args) {
        if (value) {
          return !isAfter(removeTime(value), removeTime(new Date()))
        } else return true
      }
    })
    this.$validator.extend('riType_C_AppCoins_validate', {
      getMessage(field, args) {
        return 'Not permitted when Apply Coinsurance is No. (10253)'
      },
      validate(value, args) {
        if (value) {
          let error = true
          if (value === 'C' && args[0] === 'false') {
            error = false
          }
          return error
        } else return true
      }
    })
    this.$validator.extend('riType_C_BillCoins_validate', {
      getMessage(field, args) {
        return 'Not permitted when Bill Coinsurer is No. (10254)'
      },
      validate(value, args) {
        if (value) {
          let error = true
          if (value === 'C' && args[0] !== 'Y') {
            error = false
          }
          return error
        } else return true
      }
    })
    this.$validator.extend('treaty_riCo_validate', {
      getMessage(field, args) {
        return args[0]
      },
      validate(value, args) {
        if (value) {
          let error = true
          if (args[0]) {
            error = false
          }
          return error
        } else return true
      }
    })
    this.$validator.extend('riSIPct_validate', {
      getMessage(field, args) {
        return `RI Ceded is more than 100% (${args[0]})`
      },
      validate(value, args) {
        if (value) {
          let error = true
          if (parseInt(value) > args[0]) {
            error = false
          }
          return error
        } else return true
      }
    })
  },
  beforeMount() {
    this.doInit()
  },
  watch: {
    riOutBordItems: function (value) {
      if (this.riOutBordItems.length > 0) {
        this.disableRiOutRiskPrem = true
      } else {
        this.disableRiOutRiskPrem = false
      }
    },
    displayErrorDialog: {
      handler: function(messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  components: {
    PolicyCoinsuranceServiceFee
  },
  mixins: [MessageMixin, commonMixins, riAjaxMixin, riListMixin, TableConst.default, commonAjaxMixin]
}
</script>
<style lang="scss">
.activeRow {
  background-color: #fff9c4ff;
}
.activeRowRiOutBord {
  background-color: #fff9c4ff;
}
</style>
